export default __webpack_public_path__ + "static/media/color_tubes.17cb8b02.webp";